<template>
    <div class="banner-manager">
        <div class="btn-box">
            <a-button @click="showBanner">添加banner</a-button>
        </div>
        <a-table :pagination="false" :loading="tbLoading" :data-source="list" row-key="id">
            <a-table-column
                    align="center"
                    title="廣告標題">
                <template slot-scope="row,item">
                    {{item.title}}
                </template>
            </a-table-column>
            <a-table-column
                    align="center"
                    title="廣告圖片">
                <template slot-scope="row,item">
                    <img @click="showBig(item.picPath)" :src="item.picPath" alt="" class="banner-item">
                </template>
            </a-table-column>
            <a-table-column
                    align="center"
                    title="廣告ID">
                <template  slot-scope="row,item">
                    {{item.id}}
                </template>
            </a-table-column>
            <a-table-column
                    align="center"
                    title="外鏈URL">
                <template  slot-scope="row,item">
                    {{item.linkUrl?item.linkUrl:'未設置'}}
                </template>
            </a-table-column>
            <a-table-column
                    align="center"
                    title="操作">
                <template  slot-scope="row,item">
                    <a-button type="link" @click="delBanner(item)">刪除</a-button>
                </template>
            </a-table-column>
        </a-table>
        <a-modal
                :width="700"
                v-model="show"
                title="banner圖片上傳"
                @cancel="bannerCancel"
                :confirmLoading="upLoading"
                @ok="upHandle">
            <a-form>
                <a-form-item
                        label="上傳廣告圖片"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        required
                >
                    <a-upload
                            name="avatar"
                            accept="image/*"
                            listType="picture-card"
                            class="avatar-uploader"
                            :showUploadList="false"
                            action=""
                            :disabled="updisabled"
                            :customRequest="upPic"
                    >
                        <img v-if="imageUrl" style="max-width:400px;" :src="imageUrl" alt="avatar" />
                        <div v-else>
                            <a-icon :type="updisabled ? 'loading' : 'plus'" />
                            <div class="ant-upload-text">Upload</div>
                        </div>
                    </a-upload>
                    <span style="color:red;margin-left:10px;">建议上传510*400图片</span>
                </a-form-item>
                <a-form-item
                        label="廣告標題"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        required
                ><a-input placeholder="輸入標題" v-model="title"></a-input></a-form-item>
                <a-form-item
                        label="廣告排序"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        required
                ><a-input placeholder="輸入排序" type="number" v-model="sort"></a-input></a-form-item>
                <a-form-item
                        label="外鏈URL"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        required
                ><a-input placeholder="外鏈URL" v-model="url"></a-input></a-form-item>
            </a-form>
        </a-modal>
        <a-modal
                :width="700"
                v-model="bigShow"
                :footer="null"
                title="廣告圖片">
            <img :src="bigPic" style="max-width:400px;display: block;margin:0 auto;" alt="" class="big">
        </a-modal>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                tbLoading:false,
                updisabled:false,
                imageUrl:undefined,
                id:undefined,
                show:false,
                title:undefined,
                sort:undefined,
                upLoading:false,
                list:[],
                bigPic:undefined,
                bigShow:false,
                url:undefined
            }
        },
        methods: {
            showBig(pic){
                this.bigPic=pic;
                this.bigShow=true;
            },
            hideBig(){
                this.bigShow=false;
                this.bigPic=undefined;
            },
            showBanner(){
                this.show=true;
                console.log(this.show)
            },
            bannerCancel(){
                this.show=false;
                this.id=undefined;
                this.title=undefined;
                this.sort=undefined;
                this.imageUrl=undefined;
                this.url=undefined;
                this.upLoading=false;
            },
            upHandle(){
                let self=this;
                if(!this.id){
                    this.$Message.warning('請上傳廣告圖片');
                    return false;
                }
                if(this.title === '' || !this.title){
                    this.$Message.warning('請輸入廣告標題');
                    return false;
                }
                if(this.sort === '' || !this.sort){
                    this.$Message.warning('請輸入廣告排序');
                    return false;
                }
                let data={
                    type:1,
                    picId:self.id,
                    sortNum:self.sort,
                    title:self.title,
                    bannerType:1
                }
                if(this.url){
                    data.linkUrl=this.url;
                }
                self.upLoading=true;
                self.$http({
                    method: 'post',
                    url: '/manager/banner/add',
                    data:data
                }).then(function(res){
                    self.$Message.success('操作成功')
                    self.bannerCancel()
                    self.getBanner()
                }).catch(err=>{
                })
            },
            delBanner(item){
                let self=this;
                this.$Confirm({
                    title: '提示',
                    content: '確定要山刪除該條數據嗎？',
                    onOk() {
                        return new Promise((resolve, reject) => {
                            self.$http({
                                method: 'post',
                                url: '/manager/banner/delete',
                                data:{
                                    id:item.id
                                }
                            }).then(res=>{
                                self.$Message.success('操作成功');
                                self.getBanner();
                                resolve();
                            }).catch(err=>{
                                reject()
                            })
                        })
                    },
                    onCancel() {},
                });
            },
            upPic(file){
                let self=this;
                this.updisabled=true;
                let param = new FormData()
                param.append('files', file.file)
                let config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                };
                this.$http.post('/manager/media/upload/pic',param,config)
                    .then(response => {
                        self.updisabled=false;
                        self.$Message.success('上传成功')
                        this.id= response.data.mediaInfo[0].id
                        self.imageUrl=response.data.mediaInfo[0].path;
                    }).catch(err=>{
                    self.$Message.warning('上傳失敗');
                    self.updisabled=false;
                })
            },
            getBanner(){
                let self=this;
                this.tbLoading=true;
                self.$http({
                    method: 'get',
                    url: '/manager/banner/page',
                    params:{
                        bannerType:1
                    }
                }).then(function(res){
                    self.list=res.data;
                    self.tbLoading=false;
                }).catch(err=>{
                    self.tbLoading=false;
                })
            }
        },
        created() {
            this.getBanner()
            this.$emit('breadcrumbChange',['廣告管理','PC廣告設置'])
        },
    }
</script>
<style lang="less">
    div.banner-manager{
        .btn-box{
            width:100%;
            text-align: left;
            margin-bottom:20px;
        }
        .banner-item{
            width:120px;
            height:40px;
            object-fit: cover;
            cursor:pointer;
        }
    }
</style>